import { currencySymbols } from '@utils/static';

export const FRACTION_DIGITS = {
  INTEGER: 0,
  EXCHANGE_RATES: 4,
};

function getCurrencyFormatSettings(currency) {
  let multiplier = 100;
  let fractionDigits = 2;

  if (currency) {
    const currencyName = getCryptoName(currency)?.toUpperCase();

    switch (currencyName) {
      case 'USDT':
        multiplier = 1000000; // 10^6
        fractionDigits = 6;
        break;
      case 'BTC':
        multiplier = 100000000; // 10^8
        fractionDigits = 8;
        break;
      default:
        multiplier = 100; // 10^2
        fractionDigits = 2;
        break;
    }
  }

  return { multiplier, fractionDigits };
}

export function truncateBalance(value, currency = null, fractionDigits = null) {
  const digits =
    fractionDigits ?? getCurrencyFormatSettings(currency).fractionDigits;
  const multiplier = 10 ** digits;
  const scaledValue = value * multiplier;
  return (
    Math.floor(scaledValue + Number.EPSILON * Math.abs(scaledValue)) /
    multiplier
  );
}

export function getShortage(needed, available, currency) {
  const shortage = Number((needed - available).toFixed(8));
  if (!(shortage > 0)) return 0;

  const { multiplier } = getCurrencyFormatSettings(currency);
  return Math.ceil(Number((shortage * multiplier).toFixed(6))) / multiplier;
}

export function formatBalanceUi(
  value,
  currency = null,
  fractionDigits = null,
  span = false,
) {
  const digits =
    fractionDigits ?? getCurrencyFormatSettings(currency).fractionDigits;
  const truncated = truncateBalance(value, currency, digits);

  const formatted = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  }).format(truncated);

  const symbol = currencySymbols[currency] || currency;
  if (!symbol) return formatted;

  if (span) {
    const [integerPart, fractionPart] = formatted.split('.');
    if (!fractionPart) return `${formatted} ${symbol}`;
    return `${integerPart}<span>.${fractionPart} ${symbol}</span>`;
  }
  return `${formatted} ${symbol}`;
}

export function getCryptoName(value) {
  const crypto = value?.split(' ')?.[0];
  return crypto;
}

export function removeMinusFromBalance(value) {
  const valueString = value?.toString();
  if (valueString?.startsWith('-')) {
    return valueString?.replace('-', '');
  }
  return valueString;
}
